import * as React from 'react';

import { Navigate, Outlet } from 'react-router-dom';

import MembershipTypeChangesListener from 'src/features/membershipType/components/MembershipTypeChangesListener';
import AppNavigationWrapper from 'src/features/navigation/AppNavigationWrapper';
import ScrollTop from 'src/features/navigation/components/ScrollTop';
import { PATH } from 'src/features/navigation/utils/constants';
import AdministrationRoutes from 'src/features/routes/administration';
import EntitiesRoutes from 'src/features/routes/crm';
import HomeRoutes from 'src/features/routes/home';
import MembershipsRoutes from 'src/features/routes/memberships';
import MonitoringRoutes from 'src/features/routes/monitoring';
import PaymentRoutes from 'src/features/routes/payments';
import ProfileRoutes from 'src/features/routes/profile';
import StatisticsRoutes from 'src/features/routes/statistics';
import VisitorsRoutes from 'src/features/routes/visitors';
import ValidationRoutes from 'src/features/validations/routes';
import { FallbackBlock } from 'src/registry/components/blocks/FallbackBlock';

const App = () => {
    return (
        <AppNavigationWrapper>
            <ScrollTop />
            <MembershipTypeChangesListener />
            <React.Suspense fallback={<FallbackBlock />}>
                <Outlet />
            </React.Suspense>
        </AppNavigationWrapper>
    );
};

const protectedRoutes = [
    {
        element: <App />,
        children: [
            { path: `/${PATH.HOME}`, element: <HomeRoutes /> },
            { path: `/${PATH.VISITORS}/*`, element: <VisitorsRoutes /> },
            { path: `/${PATH.MEMBERSHIPS}/*`, element: <MembershipsRoutes /> },
            { path: `/${PATH.MONITORING}/*`, element: <MonitoringRoutes /> },
            { path: `/${PATH.PAYMENTS}/*`, element: <PaymentRoutes /> },
            { path: `/${PATH.ENTITIES}/*`, element: <EntitiesRoutes /> },
            { path: `/${PATH.STATISTICS}/*`, element: <StatisticsRoutes /> },
            { path: `/${PATH.ADMINISTRATION}/*`, element: <AdministrationRoutes /> },
            { path: `/${PATH.PROFILE}/*`, element: <ProfileRoutes /> },
            { path: `/${PATH.VALIDATIONS}/*`, element: <ValidationRoutes /> },
            { path: '*', element: <Navigate to=".." /> },
        ],
    },
];

export { protectedRoutes };
